import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Button } from '@material-ui/core';

import { Label } from 'core/components/label';
import { observer } from 'mobx-react';
import { useStore } from 'core/store/store.mobx';
import { DuplicatedBindError } from 'core/store/offer-store/offer-store';

const DuplicatedBind = observer(({ classes }) => {
  const { offer: store } = useStore();
  const onClick = () => {
    store.triggerOfferDialog(false);
  };

  const error = store.errors.find((err) => err.code === DuplicatedBindError);
  return (
    <>
      <Label type="titleSecondary" className={classes.title}>
        Looks like you've already purchased this offer
      </Label>
      <Label type="infoValue" className={classes.errorMessage}>
        {error.message}
      </Label>
      <Grid container justifyContent="flex-end" className={classes.bottom}>
        <Button onClick={onClick} variant="contained" color="primary" className={classes.btn}>
          <Label className={classes.btnLabel}>Go back to checkout</Label>
        </Button>
      </Grid>
    </>
  );
});

DuplicatedBind.propTypes = {
  errors: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired
};

export default DuplicatedBind;
